import {
  CLEAR_VOLCANO_EVENT_INFO,
  GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST,
  GET_VOLCANO_EVENT_INFO_REQUEST,
  VOLCANO_EVENT_INFO_REFERENCE_SORT,
  VOLCANO_EVENT_INFO_TOGGLE_COLUMN,
} from './volcanoEventInfoReducer';

export const clearVolcanoEventInfo = () => ({ type: CLEAR_VOLCANO_EVENT_INFO });
export const getVolcanoEventInfo = ({ id, history }) => ({ type: GET_VOLCANO_EVENT_INFO_REQUEST, id, history });
export const getVolcanoEventReferences = ({ id, history }) => ({ type: GET_VOLCANO_EVENT_INFO_REFERENCES_REQUEST, id, history });
export const sortReferences = sort => ({ type: VOLCANO_EVENT_INFO_REFERENCE_SORT, sort });
export const toggleColumns = visibleColumns => ({ type: VOLCANO_EVENT_INFO_TOGGLE_COLUMN, visibleColumns });
